/* eslint-disable react/require-default-props */
import React from 'react';
import { Search } from '@rsuite/icons';

import { InputGroup, Input } from 'rsuite';
import { useDebouncedCallback } from 'use-debounce';
import PropTypes from 'prop-types';

export default function SearchInputTable({ setTextoDigitado, place, estilo }) {
  const { callback: debouncedChange } = useDebouncedCallback((value) => {
    if (typeof setTextoDigitado === 'function') {
      setTextoDigitado(value);
    }
  }, 500);

  return (
    <InputGroup
      style={{
        width: 200,
        ...estilo,
      }}
    >
      <Input
        placeholder={place || 'Pesquisar...'}
        onChange={debouncedChange}
      />

      <InputGroup.Addon>
        <Search />
      </InputGroup.Addon>
    </InputGroup>
  );
}

SearchInputTable.propTypes = {
  setTextoDigitado: PropTypes.func.isRequired,
  place: PropTypes.string,
  estilo: PropTypes.shape({
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    marginRight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
};

SearchInputTable.defaultProps = {
  place: undefined,
  estilo: undefined,
};
